export enum BIErrorType {

    Client = "Client",
    Server = "Server"
}
